const SHIRT = "M55,34 C60,30 90,30 95,34 L118,46 L136,64 L122,82 L108,72 L108,152 L42,152 L42,72 L28,82 L14,64 L32,46 Z";
const FRONT = [
  { name: "Front", x: 54, y: 72, w: 40, h: 44 },
  { name: "Left Sleeve", x: 16, y: 52, w: 20, h: 22 },
  { name: "Right Sleeve", x: 112, y: 52, w: 20, h: 22 },
];
const BACK = [
  { name: "High Neck", x: 214, y: 50, w: 46, h: 14 },
  { name: "Back", x: 210, y: 70, w: 54, h: 44 },
  { name: "Bottom Back", x: 214, y: 118, w: 46, h: 24 },
];

const LIGHT = new Set(["#ffffff", "#fff", "#f5f5f5", "#eeeeee", "#e5e5e5", "#d1d5db", "#f3f4f6"]);

export function GarmentDiagram({ placements, options, onToggle, color, art, fileUrl, view = "both", compact = false }) {
  const names = new Set((options || []).map((o) => o.name));
  const has = (n) => placements.includes(n);
  const shirtFill = color || "#15181f";
  const light = LIGHT.has((color || "").toLowerCase());
  const outline = light ? "#9ca3af" : "#3a3f4b";
  const clickable = typeof onToggle === "function";
  const src = (n) => {
    const a = (art || {})[n];
    return a && a.image_url ? (fileUrl ? fileUrl(a.image_url) : a.image_url) : null;
  };
  const viewBox = view === "front" ? "0 0 150 200" : view === "back" ? "155 0 148 200" : "0 0 320 200";

  const Zone = ({ z }) => {
    if (!names.has(z.name)) return null;
    const on = has(z.name);
    const img = on ? src(z.name) : null;
    const clipId = `clip-${z.name.replace(/\s+/g, "-")}`;
    return (
      <g onClick={() => clickable && onToggle(z.name)} data-testid={`diagram-zone-${z.name}`} style={{ cursor: clickable ? "pointer" : "default" }}>
        <rect x={z.x} y={z.y} width={z.w} height={z.h} rx="4"
          fill={on && !img ? "#ff6a13" : "#00000000"} fillOpacity={on && !img ? 0.7 : 1}
          stroke={on ? "#ff6a13" : (light ? "#9ca3af" : "#4b5563")} strokeWidth="1.5"
          strokeDasharray={on ? "0" : "3 2"} />
        {img && (
          <g>
            <clipPath id={clipId}><rect x={z.x} y={z.y} width={z.w} height={z.h} rx="4" /></clipPath>
            <image href={img} x={z.x} y={z.y} width={z.w} height={z.h}
              preserveAspectRatio="xMidYMid meet" clipPath={`url(#${clipId})`} />
          </g>
        )}
      </g>
    );
  };

  const showFront = view !== "back";
  const showBack = view !== "front";

  return (
    <div className={compact ? "" : "rounded-xl border border-zinc-800 bg-[#0e1015] p-3 mb-3"} data-testid="garment-diagram">
      <svg viewBox={viewBox} className={compact ? "w-full h-auto" : "w-full h-auto max-h-56"}>
        {showFront && <path d={SHIRT} fill={shirtFill} stroke={outline} strokeWidth="2" />}
        {showBack && <path d={SHIRT} transform="translate(162,0)" fill={shirtFill} stroke={outline} strokeWidth="2" />}
        {showFront && <path d="M55,34 C60,44 90,44 95,34" fill="none" stroke={outline} strokeWidth="2" />}
        {showBack && <path d="M217,34 C222,40 252,40 257,34" fill="none" stroke={outline} strokeWidth="2" />}
        {showFront && FRONT.map((z) => <Zone key={z.name} z={z} />)}
        {showBack && BACK.map((z) => <Zone key={z.name} z={z} />)}
        {!compact && showFront && <text x="75" y="170" textAnchor="middle" fill={light ? "#6b7280" : "#71717a"} fontSize="9" fontFamily="monospace">FRONT</text>}
        {!compact && showBack && <text x="237" y="170" textAnchor="middle" fill={light ? "#6b7280" : "#71717a"} fontSize="9" fontFamily="monospace">BACK</text>}
      </svg>
      {!compact && clickable && <p className="text-[10px] text-zinc-600 text-center mt-1">Live preview · tap an area to add or remove a placement</p>}
    </div>
  );
}
